import { render, staticRenderFns } from "./inflections-browser.vue?vue&type=template&id=1bbb320f&"
import script from "./inflections-browser.vue?vue&type=script&lang=js&"
export * from "./inflections-browser.vue?vue&type=script&lang=js&"
import style0 from "./inflections-browser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bbb320f', component.options)
    } else {
      api.reload('1bbb320f', component.options)
    }
    module.hot.accept("./inflections-browser.vue?vue&type=template&id=1bbb320f&", function () {
      api.rerender('1bbb320f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections-browser.vue"
export default component.exports